import dayjs from 'dayjs';

/** 获取mock变量 */
export const getMockVar = (key: string) => window.__mock__?.[key];

/** 活动切图 CDN 基础路径 */
export const LOTTERY_IMAGE_CDN_BASE = 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20260818201248';

/** 分享切图 CDN 基础路径 */
export const LOTTERY_SHARE_IMAGE_CDN_BASE = 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20260819111017';

/** 抽奖开始时间 */
export const LOTTERY_START_TIME = getMockVar('LOTTERY_START_TIME') || dayjs('2026-08-26T00:00:00+08:00').toDate();
/** 抽奖结束时间 */
export const LOTTERY_END_TIME = getMockVar('LOTTERY_END_TIME') || dayjs('2026-11-25T23:59:59+08:00').toDate();
/** 推广展示结束时间（用于 Banner 文案计算） */
export const PROMOTION_END_TIME = getMockVar('PROMOTION_END_TIME') || dayjs('2026-11-24T23:59:59+08:00').toDate();

/** banner-活动进行中 */
export const LOTTERY_BANNER = 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20260819143340/main-banner-tiny.png';

/** 活动规则半屏顶图（活动参与流程图） */
export const LOTTERY_INFO_DIALOG_PICTURE = `${LOTTERY_IMAGE_CDN_BASE}/tnc-dialog.png`;

/** 维他专属分享券卡片切图 */
export const SHARE_COUPON_BANNER = `${LOTTERY_SHARE_IMAGE_CDN_BASE}/share-coupon-banner-tiny.png`;

/** 牌照号码 */
export const LICENSE_NUMBER = '61716-7';

/** 牌照展示文案（banner / 弹窗 / 规则半屏三处复用） */
export const LICENSE_DISPLAY_TEXT = `推廣生意的競賽牌照號碼：${LICENSE_NUMBER} (只適用於抽獎活動)`;

/** 推广日期文案（由时间常量动态拼接，支持 mock 覆盖） */
export const getPromotionDateText = (): string => {
  const startDate = dayjs(LOTTERY_START_TIME).format('YYYY年M月D日');
  const endDate = dayjs(PROMOTION_END_TIME).format('YYYY年M月D日');
  return `推廣日期：${startDate}-${endDate}（首尾兩天包含在內）`;
};

/** 活动规则半屏底部文案 */
export const getInfoDialogBottomText = (): string => `${getPromotionDateText()}<br />
${LICENSE_DISPLAY_TEXT}<br />
<br />
參與本推廣活動，<br />
每次抽獎將有機會隨機獲得價值HK$668電子現金券、價值HK$88電子現金券、價值HK$8電子現金券、價值HK$1電子現金券、價值HK$0.5 電子現金券或價值HK$2維他®冷泡無糖茶優惠券1張。<br />
<br />
本推廣活動受相關條款及細則約束<br />
<br />
有關本推廣活動資訊（價值HK$2優惠券的使用）及維他奶國際集團有限公司（"維他奶公司"）提供之產品的質量事宜均由維他奶公司自行負責，用戶應直接向維他奶公司查詢及反映，WeChat Pay Hong Kong對前述資訊及事項（包括任何有關產品質量或因產品自身引起的任何責任）概不負責。`;

export const INFO_DIALOG_CONFIG = {
  picture: LOTTERY_INFO_DIALOG_PICTURE,
  tncUrl: 'https://hkwallet.moneydata.hk/hkwalletv3/tnc/index.shtml#/?type=wecoupon_2026&tncId=vitaScan',
  get bottomText() {
    return getInfoDialogBottomText();
  },
};

/** 携带抽奖 cdkey 的 adtag 白名单 */
export const LOTTERY_ADTAG_WHITELIST = ['26qrinapp', '26qroutapp'];

/* ---------------- 2608 活动（維他冷泡無糖茶開蓋即Scan 解鎖驚喜） ---------------- */

/** 2608 活动跳转 adtag（优惠券列表、优惠专区、分享等统一使用） */
export const ACT_2608_ADTAG_JUMP = 'vitasoy2608';

/** 活动未开始拦截弹窗 */
export const ACT_NOT_START_DIALOG = {
  content: '維他冷泡無糖茶開蓋即Scan 解鎖驚喜活動將於2026年8月26日開始。敬請留意!',
  btnText: '好的',
};
